export default __webpack_public_path__ + "static/media/fitnessTracker-sq.01d615e7.png";